import { render } from "./endorsed.vue?vue&type=template&id=ec468e26&scoped=true"
import script from "./endorsed.vue?vue&type=script&lang=js"
export * from "./endorsed.vue?vue&type=script&lang=js"

import "./endorsed.vue?vue&type=style&index=0&id=ec468e26&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec468e26"],['__file',"src/views/my/endorsed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec468e26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec468e26', __exports__)) {
    console.log('reload')
    api.reload('ec468e26', __exports__)
  }
  
  module.hot.accept("./endorsed.vue?vue&type=template&id=ec468e26&scoped=true", () => {
    console.log('re-render')
    api.rerender('ec468e26', render)
  })

}


export default __exports__